import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import React from "react"
import * as style from "./style.module.css"
import Map from "/src/components/Map"
import json from "/src/siteData.json"
import { getPathFromTemplateType } from "/src/utils/getPathFromTemplateType"

const data = json.footer
const logoUri = json.header.logoUri
const siteMetaData = json.siteMetadata

const Component = () => {
  return (
    <>
      <Map address={data.address} />
      <footer className={style.container}>
        <img src={logoUri} alt={siteMetaData.title} width={120} height={51} />
        <div className={style.phone_number}>
          <a
            className={style.phone_number_link}
            href={`tel:+81${data.phoneNumber}`}
          >
            TEL: <span>{data.phoneNumber}</span>
          </a>
        </div>
        <div className={style.sns}>
          <ul className={style.sns_list}>
            {data.facebookUrl && (
              <li>
                <Link to={data.facebookUrl}>
                  <StaticImage
                    src="../../images/icons/sns-facebook-bk.svg"
                    placeholder="none"
                    loading="eager"
                    formats={["auto", "webp", "avif"]}
                    alt="Facebook"
                  />
                </Link>
              </li>
            )}
            {data.instagramUrl && (
              <li>
                <Link to={data.instagramUrl}>
                  <StaticImage
                    src="../../images/icons/sns-instagram-bk.svg"
                    placeholder="none"
                    loading="eager"
                    formats={["auto", "webp", "avif"]}
                    alt="Instagram"
                  />
                </Link>
              </li>
            )}
            {data.lineUrl && (
              <li>
                <Link to={data.lineUrl}>
                  <StaticImage
                    src="../../images/icons/sns-line-bk.svg"
                    placeholder="none"
                    loading="eager"
                    formats={["auto", "webp", "avif"]}
                    alt="LINE"
                  />
                </Link>
              </li>
            )}
            {data.xUrl && (
              <li>
                <Link to={data.xUrl}>
                  <StaticImage
                    src="../../images/icons/sns-x-bk.svg"
                    placeholder="none"
                    loading="eager"
                    formats={["auto", "webp", "avif"]}
                    alt="X"
                  />
                </Link>
              </li>
            )}
            {data.blogUrl && (
              <li>
                <Link to={data.blogUrl}>
                  <StaticImage
                    src="../../images/icons/sns-blog-bk.svg"
                    placeholder="none"
                    loading="eager"
                    formats={["auto", "webp", "avif"]}
                    alt="BLOG"
                  />
                </Link>
              </li>
            )}
          </ul>
        </div>
        <Link
          className={style.privacy_policy_link}
          to={getPathFromTemplateType(5)}
        >
          プライバシーポリシー
        </Link>
        <small className={style.copyright}>&copy; {data.copyright}</small>
      </footer>
    </>
  )
}

export default Component
